import { isRequired } from '@gef-ui/form-core/validations/validationFunctions/common';

import isCampaignTemplateName from 'app/forms/validations/isCampaignTemplateName';

export const SAVE_TEMPLATE_FORM_NAME = 'saveTemplate-filter';

export const FIELDS = {
	templateName: 'templateName',
};

export default () => ({
	[FIELDS.templateName]: {
		deepPath: [FIELDS.templateName],
		validations: [isRequired(), isCampaignTemplateName()],
	},
});
